import { Order } from "../models/order.model";
import { createReducer, on, StoreFeatureModule } from "@ngrx/store";
import {
  initialState,
  UI__REQUEST_SET_LANG,
  UI__SET_LANG,
  UI__ROUTE_NAVIGATION,
  UI__SIDEBAR_ROUTE_NAVIGATION,
  UI__SET_ACTIVE_TABS,
  UI__TAB_NAVIGATION,
  UI__TOGGLE_MOBILE_NAV,
  ERROR__FROM_SERVER,
  USER_SWITCH_CLINIC,
  USER_SIGN_OUT,
  GET_ORDERS,
  RUN_ORDERS_SEARCH,
  GET_CLINIC_LIST,
  GET_CLINIC_CHAIN_LIST,
  GET_SYSTEM_PARAMS,
  GET_DOCTOR_LIST,
  GET_URGENCY_LIST,
  GET_STAGE_LIST,
  CREATED_CHAT_TASK,
  GET_CHAT_TASK_STATUS_LIST,
  GET_PLANT_LIST,
  GET_ROLE_LIST,
  GET_SUPPLY_TYPES_LIST,
  SELECT_INBOX_ORDER,
  PATCH_INBOX_ORDER,
  RELOAD_CURRENT_ORDER,
  GET_SUPPLY_ORDERS,
  APPROVE_SUPPLY_ORDER,
  CREATE_SUPPLY_ORDER,
  SUPPLIES_SELECT_CLINIC,
  RUN_USERS_SEARCH,
  RUN_CLINICS_SEARCH,
  GET_CLINIC_DETAILS,
  GET_TASK_USERS,
  GET_USERS,
  EDIT_USER,
  UPDATE_USER,
  GET_USER_NOTIFICATIONS,
  SELECT_INBOX_RESULTS_PER_PAGE,
  SELECT_CHAT_CONTACT,
  SEND_FILE_CHAT_MSG,
  SELECT_REPORT_SCREEN_TYPE,
  RUN_REPORTS_SEARCH,
  CLEAR_REPORTS_SEARCH,
  GET_CLIENT_BALANCE,
  GET_CLIENT_INVOICES,
  GET_CLIENT_RECEIPTS,
  GET_TOTAL_DEBT,
  GET_DASHBOARD_DATA,
  SELECT_SUPPLY_TYPE,
  REQUEST_DASHBOARD_REFRESH,
  GET_AGENTS_LIST,
  GET_CLINIC_USERS,
  GET_LABS_KPI,
  GET_OPERATION_REPORTS,
  SELECT_CHAT_TASK,
  GO_TO_CLINIC_KPI,
  GET_AGENT_CLINIC_LIST,
  GET_AGENT_TASKS,
  GET_DR_PROFILES,
  RUN_DR_PROFILES_SEARCH,
  GET_TECHINICIANS_LIST,
  GET_RX_OPT,
  GET_TECH_ISSUES_LIST,
  CREATE_TASK_FOR_CHAT_MSG,
  SELECT_RX_FORM,
  GET_RX_PRESET_NOTES,
  GET_RX_ITEMS,
  GET_PRESET_NOTES,
  GET_GENERAL_TASKS_USERS,
  RELOAD_INBOX,
  MARK_INBOX_NEEDS_RELOAD,
  GET_ORDER_HEADER_INIT,
  FOCUS_ORDER_CHAT_TAB,
  UI__HIGHLIGHT_TABS,
  UI__ADD_TO_TAB_STORE,
  UI__REMOVE_FROM_TAB_STORE,
  GET_ORDER_EMAIL_TEMPLATE_LIST,
  GET_KPI_CONFIG,
  SET_DISPLAYED_FILE,
  CLEAR_DISPLAYED_FILE,
  GET_DELIVERERS_LIST,
  GET_DISTRIBUTION_WAYBILLS,
} from "./ngrx-actions";
import { AuthService } from "../services/auth.service";
import { SharedService } from "../services/shared.service";

const PATCH_PROTECTED_FIELDS: (keyof Order)[] = [
  "chatContacts",
  "chatTasks",
  "activityLog",
  "drProfile",
  "files",
  "filesRX",
  "orderLines",
  "notes",
  "dueDateChangeAccept",
];

export const rootReducer = createReducer(
  initialState,
  on(UI__REQUEST_SET_LANG, (state, { lang }) => ({
    ...state,
    ui_requestSetLang: lang,
  })),
  on(UI__SET_LANG, (state, { lang, direction }) => {
    SharedService.ui_lang = lang;
    return {
      ...state,
      ui_direction: direction,
    };
  }),
  on(UI__ROUTE_NAVIGATION, (state, { data }) => ({
    ...state,
    ui_navigation: data,
  })),
  on(UI__SIDEBAR_ROUTE_NAVIGATION, (state, { data }) => ({
    ...state,
    ui_navigation: data,
  })),
  on(UI__SET_ACTIVE_TABS, (state, { data }) => ({
    ...state,
    ui_activeTabs: new Array().concat(data) || [],
  })),
  on(UI__TAB_NAVIGATION, (state, { data }) => ({
    ...state,
    ui_tabNavigation: data,
  })),
  on(UI__REMOVE_FROM_TAB_STORE, (state, { tabStoreKey }) => {
    state.ui_tabStore.delete(tabStoreKey);
    return { ...state };
  }),
  on(UI__ADD_TO_TAB_STORE, (state, { tabStoreKey, tabs }) => {
    state.ui_tabStore.set(tabStoreKey, tabs);
    return { ...state };
  }),
  on(UI__TOGGLE_MOBILE_NAV, (state, { mobileNavOpen }) => ({
    ...state,
    ui_mobileNavOpen: mobileNavOpen,
  })),
  on(ERROR__FROM_SERVER, (state, { data }) => ({
    ...state,
    _errorFromServer: data,
  })),
  on(USER_SWITCH_CLINIC, (state, { clinicId }) => ({
    ...state,
    ...initialState,
    userSelectedClinicId: clinicId,
    currentDisplayedFileId: null,
  })),
  on(USER_SIGN_OUT, (state) => ({
    ...initialState,
    currentDisplayedFileId: null,
  })),
  on(GET_ORDERS, (state, { data, medataData, qcModeSw }) => ({
    ...state,
    orders: data,
    orderSearchMetadata: medataData,
    qcModeSw: qcModeSw,
  })),
  on(RUN_ORDERS_SEARCH, (state, { newSearch }) => ({
    ...state,
    currentOrder: null,
    currentChatContact: null,
    orders: newSearch ? null : state.orders,
    inboxNeedsReload: newSearch ? false : state.inboxNeedsReload,
  })),
  on(MARK_INBOX_NEEDS_RELOAD, (state) => ({
    ...state,
    inboxNeedsReload: true,
  })),
  on(GET_ORDER_HEADER_INIT, (state, { orderSearchMetadata }) => ({
    ...state,
    orderSearchMetadata: orderSearchMetadata,
  })),
  on(GET_CLINIC_LIST, (state, { data }) => ({
    ...state,
    clinicList: data,
  })),
  on(GET_CLINIC_CHAIN_LIST, (state, { data }) => ({
    ...state,
    clinicChainList: data,
  })),
  on(GET_SYSTEM_PARAMS, (state, { data }) => ({
    ...state,
    systemParams: data,
  })),
  on(GET_DOCTOR_LIST, (state, { data }) => ({
    ...state,
    doctorList: data,
  })),
  on(GET_URGENCY_LIST, (state, { data }) => ({
    ...state,
    urgencyList: data,
  })),
  on(GET_STAGE_LIST, (state, { data }) => ({
    ...state,
    stageList: data,
  })),
  on(GET_CHAT_TASK_STATUS_LIST, (state, { data }) => ({
    ...state,
    chatTaskStatusList: data,
  })),
  on(CREATED_CHAT_TASK, (state, { data }) => ({
    ...state,
  })),
  on(GET_PLANT_LIST, (state, { data }) => ({
    ...state,
    plantList: data,
  })),
  on(GET_ROLE_LIST, (state, { data }) => ({
    ...state,
    roleList: data,
  })),
  on(GET_SUPPLY_TYPES_LIST, (state, { data }) => ({
    ...state,
    supplyTypesList: data,
  })),
  on(GET_DELIVERERS_LIST, (state, { data }) => ({
    ...state,
    deliverersList: data,
  })),
  on(SELECT_INBOX_ORDER, (state, { order }) => ({
    ...state,
    currentChatContact: null,
    currentChatTask: null,
    currentFileToSend: null,
    curRXForm: null,
    currentDisplayedFileId: null,
    currentOrder: order,
  })),
  on(PATCH_INBOX_ORDER, (state, { orderId, changes }) => {
    // merge into a copy that keeps the Order prototype (its getters), and
    // leave the state alone when the order is not listed
    // detail data of an open order is never part of a header patch
    const header = { ...changes };
    for (const k of PATCH_PROTECTED_FIELDS) delete header[k];
    const patch = (o: Order) =>
      Object.assign(Object.create(Object.getPrototypeOf(o)), o, header);
    const listed = state.orders?.some((o) => o.orderId == orderId);
    const isCurrent = state.currentOrder?.orderId == orderId;
    if (!listed && !isCurrent) return state;
    return {
      ...state,
      orders: listed
        ? state.orders.map((o) => (o.orderId == orderId ? patch(o) : o))
        : state.orders,
      currentOrder: isCurrent ? patch(state.currentOrder) : state.currentOrder,
    };
  }),
  on(RELOAD_CURRENT_ORDER, (state, { order }) => {
    order.chatContacts = state.currentOrder.chatContacts;
    order.chatTasks = state.currentOrder.chatTasks;
    order.activityLog = state.currentOrder.activityLog;
    order.drProfile = state.currentOrder.drProfile;
    let orders = state.orders;
    let idx = orders.findIndex((o) => o.orderId == order.orderId);
    if (idx != -1) {
      orders[idx] = order;
    }

    return {
      ...state,
      currentOrder: order,
      orders: orders,
    };
  }),
  on(FOCUS_ORDER_CHAT_TAB, (state, { focusOrderChatTab }) => ({
    ...state,
    focusOrderChatTab: true,
  })),
  on(GET_SUPPLY_ORDERS, (state, { data, medataData }) => ({
    ...state,
    supplyOrders: data,
    supplyOrderSearchMetadata: medataData,
  })),
  on(APPROVE_SUPPLY_ORDER, (state) => ({ ...state })),
  on(CREATE_SUPPLY_ORDER, (state) => {
    state.supplyTypesList.forEach((i) => (i.selected = false));
    return {
      ...state,
      supplyTypesList: state.supplyTypesList,
      supplySelectedClinic: null,
    };
  }),
  on(SUPPLIES_SELECT_CLINIC, (state, { clinic }) => ({
    ...state,
    supplySelectedClinic: clinic,
  })),
  on(RUN_USERS_SEARCH, (state, { newSearch }) => ({
    ...state,
    selectedUser: null,
    users: newSearch ? null : state.users,
    mngSelectedClinic: null,
  })),
  on(RUN_CLINICS_SEARCH, (state, { newSearch }) => ({
    ...state,
    mngSelectedClinic: null,
    clinicsDetails: newSearch ? null : state.clinicsDetails,
  })),
  on(GET_USERS, (state, { data, medataData }) => ({
    ...state,
    users: data,
    usersSearchMetadata: medataData,
  })),
  on(GET_TASK_USERS, (state, { data, medataData }) => ({
    ...state,
    taskUsersList: data,
    usersSearchMetadata: medataData,
  })),
  on(GET_CLINIC_DETAILS, (state, { data, medataData }) => ({
    ...state,
    clinicsDetails: data,
    clinicsSearchMetadata: medataData,
  })),
  on(EDIT_USER, (state, { user }) => ({
    ...state,
    selectedUser: user,
  })),
  on(UPDATE_USER, (state, { user }) => ({
    ...state,
    lastSavedUser: user,
  })),
  on(GET_USER_NOTIFICATIONS, (state, { data }) => ({
    ...state,
    userNotifications: data,
  })),
  on(SELECT_INBOX_RESULTS_PER_PAGE, (state, { inboxResultsPerPage }) => ({
    ...state,
    inboxResultsPerPage: inboxResultsPerPage,
  })),
  on(SELECT_CHAT_CONTACT, (state, { chatContact }) => ({
    ...state,
    currentChatContact: chatContact,
  })),
  on(SEND_FILE_CHAT_MSG, (state, { orderFile, chatContact }) => ({
    ...state,
    currentChatContact: chatContact,
    currentFileToSend: orderFile,
  })),
  on(SELECT_REPORT_SCREEN_TYPE, (state, { screenType }) => ({
    ...state,
    currentReportScreenType: screenType,
  })),
  on(RUN_REPORTS_SEARCH, (state, { searchParams }) => ({
    ...state,
    curReportBalanceRows: null,
    curReportInvoices: null,
    curReportReceipts: null,
    balanceSearchMetadata: null,
    invoicesSearchMetadata: null,
    receiptsSearchMetadata: null,
    reportsSearchParams: searchParams,
  })),
  on(CLEAR_REPORTS_SEARCH, (state) => ({
    ...state,
    curReportInvoices: null,
    invoicesSearchMetadata: null,
    curReportReceipts: null,
    receiptsSearchMetadata: null,
    curReportBalanceRows: null,
    balanceSearchMetadata: null,
    reportsSearchParams: null,
    curTotalDept: null,
  })),
  on(GET_CLIENT_INVOICES, (state, { data, medataData }) => ({
    ...state,
    curReportInvoices: data,
    invoicesSearchMetadata: medataData,
  })),
  on(GET_CLIENT_RECEIPTS, (state, { data, medataData }) => ({
    ...state,
    curReportReceipts: data,
    receiptsSearchMetadata: medataData,
  })),
  on(GET_CLIENT_BALANCE, (state, { data, medataData }) => ({
    ...state,
    curReportBalanceRows: data,
    balanceSearchMetadata: medataData,
  })),
  on(GET_TOTAL_DEBT, (state, { data }) => ({
    ...state,
    curTotalDept: data,
  })),
  on(SELECT_SUPPLY_TYPE, (state, { type }) => ({
    ...state,
    selectedSupplyType: type,
  })),
  on(GET_DASHBOARD_DATA, (state, { data }) => ({
    ...state,
    dashboardData: data,
  })),
  on(REQUEST_DASHBOARD_REFRESH, (state) => ({ ...state })),
  on(GET_CLINIC_USERS, (state, { clinic }) => ({
    ...state,
    mngSelectedClinic: clinic,
  })),
  on(SELECT_CHAT_TASK, (state, { task }) => ({
    ...state,
    currentChatTask: task,
  })),
  on(GET_OPERATION_REPORTS, (state, { data }) => ({
    ...state,
    operationReports: data,
  })),
  on(GET_AGENTS_LIST, (state, { data }) => ({
    ...state,
    agentsList: data,
  })),
  on(GET_LABS_KPI, (state, { data }) => ({
    ...state,
    labKpi: data,
  })),
  on(GO_TO_CLINIC_KPI, (state, { clinicId }) => ({
    ...state,
    selectedClinicForKpi: clinicId,
  })),
  on(GET_AGENT_CLINIC_LIST, (state, { data }) => ({
    ...state,
    agentClinicList: data,
  })),
  on(GET_AGENT_TASKS, (state, { data, medataData }) => ({
    ...state,
    agentTasks: data,
    agentTasksSearchMetadata: medataData,
  })),
  on(GET_DR_PROFILES, (state, { data, medataData }) => ({
    ...state,
    drProfiles: data,
    drProfilesSearchMetadata: medataData,
  })),
  on(RUN_DR_PROFILES_SEARCH, (state, { newSearch }) => ({
    ...state,
    drProfiles: newSearch ? null : state.drProfiles,
  })),
  on(GET_RX_OPT, (state, { data }) => ({
    ...state,
    rxOpt: data,
  })),
  on(GET_TECHINICIANS_LIST, (state, { data }) => ({
    ...state,
    techiniciansList: data,
  })),
  on(GET_TECH_ISSUES_LIST, (state, { data }) => ({
    ...state,
    techIssuesList: data,
  })),
  on(CREATE_TASK_FOR_CHAT_MSG, (state) => ({ ...state })),
  on(SELECT_RX_FORM, (state, { form }) => ({
    ...state,
    curRXForm: form,
  })),
  on(GET_RX_PRESET_NOTES, (state, { data }) => ({
    ...state,
    rxPresetNotes: data,
  })),
  on(GET_RX_ITEMS, (state, { data }) => ({
    ...state,
    rxItems: data,
  })),
  on(GET_TECH_ISSUES_LIST, (state, { data }) => ({
    ...state,
    techIssuesList: data,
  })),
  on(GET_KPI_CONFIG, (state, { data }) => ({
    ...state,
    kpiConfig: data,
  })),
  on(GET_PRESET_NOTES, (state, { data, medataData }) => ({
    ...state,
    presetNotes: data,
    presetNotesSearchMetadata: medataData,
  })),
  on(SET_DISPLAYED_FILE, (state, { fileId }) => ({
    ...state,
    currentDisplayedFileId: fileId,
  })),
  on(CLEAR_DISPLAYED_FILE, (state) => ({
    ...state,
    currentDisplayedFileId: null,
  })),
  on(GET_GENERAL_TASKS_USERS, (state, { data }) => ({
    ...state,
    generalTaskUsersList: data,
  })),
  on(GET_ORDER_EMAIL_TEMPLATE_LIST, (state, { data }) => ({
    ...state,
    orderEmailTemplateList: data,
  })),
  on(RELOAD_INBOX, (state) => ({ ...state })),
  on(UI__HIGHLIGHT_TABS, (state) => ({ ...state })),
  on(GET_DISTRIBUTION_WAYBILLS, (state, { data, medataData }) => ({
    ...state,
    distributionWaybills: data,
    distributionWaybillsSearchMetadata: medataData,
  }))
);
